import { useMemo } from "react";
import { useAtomValue } from "jotai";
import { usePageContext } from "./usePageContext";
import { sessionAtom } from "../features/accounts/account.state";

export interface UserAppState {
  currentRoute: string;
  feature?: string;
  catalogId?: number;
  productId?: number;
  pageState?: {
    hasCatalog: boolean;
    hasProducts: boolean;
    catalogName?: string;
    productCount?: number;
  };
}

/**
 * Hook to build UserAppState for AI semantic actions
 * Combines page context with account summary data
 */
export const useUserAppState = (): UserAppState => {
  const pageContext = usePageContext();
  const session = useAtomValue(sessionAtom);

  return useMemo(() => {
    const state: UserAppState = {
      currentRoute: pageContext.route,
      feature: pageContext.feature,
      catalogId: pageContext.catalogId,
      productId: pageContext.productId,
    };

    // Add page state flags from account summary
    if (session?.account?.summary) {
      const summary = session.account.summary;
      state.pageState = {
        hasCatalog: (summary.catalogsCount ?? 0) > 0,
        hasProducts: (summary.itemsCount ?? 0) > 0,
        productCount: summary.itemsCount,
      };

      // Add current catalog name if we're on a catalog page
      // TODO: Could fetch from catalog cache/state if needed
    }

    return state;
  }, [pageContext, session?.account?.summary]);
};
